import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DISTRICTS from '../data/districts';

// Double the list so the marquee loops seamlessly
const MARQUEE_ITEMS = [...DISTRICTS, ...DISTRICTS];

export default function SocialProofBar() {
  return (
    <Box
      sx={{
        backgroundColor: '#F7F7F7',
        borderTop: '2px solid #1e1e1e',
        borderBottom: '2px solid #1e1e1e',
        py: { xs: 3, md: 4 },
        overflow: 'hidden',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Montserrat, Inter, sans-serif',
          fontSize: { xs: '0.75rem', md: '0.8rem' },
          fontWeight: 700,
          color: '#2C2C2C',
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          textAlign: 'center',
          mb: 2,
          px: 3,
        }}
      >
        Trusted by 100+ of the largest school districts in North America
      </Typography>

      {/* Scrolling marquee */}
      <Box
        sx={{
          display: 'flex',
          width: 'max-content',
          animation: 'marquee 40s linear infinite',
          '&:hover': { animationPlayState: 'paused' },
          '@keyframes marquee': {
            '0%': { transform: 'translateX(0)' },
            '100%': { transform: 'translateX(-50%)' },
          },
        }}
      >
        {MARQUEE_ITEMS.map((district, i) => (
          <Box
            key={`${district}-${i}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'nowrap',
              px: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Lato, Inter, sans-serif',
                fontSize: { xs: '0.8rem', md: '0.9rem' },
                color: '#666',
                fontWeight: 500,
              }}
            >
              {district}
            </Typography>
            <Typography sx={{ color: '#CCC', mx: 2, fontSize: '0.5rem' }}>
              &#9679;
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
